import React from "react";
import { func, string } from "prop-types";
import Button from "pages/_components/Button";
import ReactTagWithoutInput from "./ReactTagWithoutInput";

const FilterTags = ({ openSideBarFilters, option }) => (
    <div className="tags-filter">
        <Button
            image="images/figma/icon/filter.svg"
            onClick={openSideBarFilters}
            label="global.filter"
            className="btn btn-link open-filters"
            block={false}
        />
        <ReactTagWithoutInput option={option} />
    </div>
);

FilterTags.propTypes = {
    openSideBarFilters: func.isRequired,
    option: string.isRequired,
};

export default FilterTags;
